import { randomArray } from '@library/common/functions';
import { MockPath, MockPagination } from '@library/common/http/mock-path.mock';

import {
   MockAdminUser,
   MockAdminUserListItem
} from './admin-user.mock';

export const AdminUserRoutes: MockPath<any>[] = [
   {
      path: 'admin/user/list',
      verb: 'POST',
      response: opts => ({
         collection: randomArray( MockAdminUserListItem ),
         pagination: MockPagination( opts?.body?.pagination ),
      }),
   },
   {
      path: 'admin/user/.+',
      verb: 'GET',
      collection: _ => [ new MockAdminUser() ]
   },
];
